module.exports = __webpack_public_path__ + "media/images/masks/avatar-status-7ca4c2012feeb8ac3a01a078c0177b36.svg";